import React, { useState } from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { logErrorToConsole } from 'src/utils/util';
import {
    FilterComponentWrapper,
    FilterComponentHeaderFooter,
    TextBold,
    LineSeparator,
    SearchBoxContainer,
} from './FilterView.styled';
import CommonRadioCheckboxFilter from 'src/common/refactoredComponents/filter/CommonRadioCheckboxFilter';
import FilterAccountLabel from 'src/common/refactoredComponents/filter/components/FilterAccountLabel';
import SearchBox from 'src/common/refactoredComponents/searchbox/index';
import { Dot } from 'src/styles/CommonStyles.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const CustomizeFilterView = ({
    header,
    PlaceHolder,
    defaultViewFilter,
    selectedViewFilter,
    setSelectedViewFilter,
    isExpanded,
    updateExpandedViews,
    viewFiltersLists,
    viewFilterName,
    showDefault, //Boolean Used to Show Default Label in Calendar Page
    setDefaultAction, //Boolean Used to  Show Default Button in Calendar Page
    isAccountView,
    width,
    whiteSpace,
    smbWidth,
    overFlow,
    textOverflow,
    showDot, //Show Dot in View Header
    isFilterDisable, //Boolean to make disable when filter list is empty

    setDefaultCalendarView = () => {},
    showFavourite = false,
}) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');
    const checkIfDefault = (filterId) => {
        if (filterId === defaultViewFilter?.id) {
            return true;
        } else {
            return false;
        }
    };
    const hasDefaultViewChanged = () => {
        if (
            !selectedViewFilter?.id ||
            selectedViewFilter?.id === defaultViewFilter?.id
        ) {
            return false;
        } else {
            return true;
        }
    };
    const updateSearch = (val) => {
        setSearchValue(val);
    };
    return (
        <FilterComponentWrapper
            className={
                isFilterDisable
                    ? viewFiltersLists?.filter(
                          (item) =>
                              item.name !== 'All' &&
                              item.name !== 'All Districts' &&
                              item.name !== 'All Territories'
                      ).length > 0
                        ? ''
                        : 'disabled'
                    : ''
            }
        >
            <FilterComponentHeaderFooter
                id={`admin-filter-customizeFilterView-header-${viewFilterName}`}
                onClick={() => {
                    try {
                        updateExpandedViews({
                            view: viewFilterName,
                            value: !isExpanded,
                        });
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
            >
                <TextBold color={'#140F4B'}>{header}</TextBold>
                <div>
                    {(() => {
                        if (isExpanded) {
                            return (
                                <>
                                    <img
                                        src={DownArrowFilter}
                                        style={{ transform: 'rotate(180deg)' }}
                                    ></img>
                                </>
                            );
                        } else {
                            return (
                                <>
                                    {showDot ? <Dot /> : ''}
                                    <img src={DownArrowFilter}></img>
                                </>
                            );
                        }
                    })()}
                    {/* <img
                        src={isExpanded ? UpArrowFilter : DownArrowFilter}
                    ></img> */}
                </div>
            </FilterComponentHeaderFooter>
            {(() => {
                if (isExpanded) {
                    return (
                        <>
                            <SearchBoxContainer>
                                <SearchBox
                                    id="admin-filter-customizeFilterView-searchbox"
                                    updateSearch={updateSearch}
                                    searchProduct={searchValue}
                                    placeholder={
                                        t('admin.adminList.search') +
                                        ' ' +
                                        PlaceHolder
                                    }
                                    width={'100%'}
                                    padding={'8px 37px 10px 37px'}
                                    borderRadius={'25px'}
                                    marginDesktop={'0 15px 15px'}
                                    filterPage = {true}
                                    isSearchIcon={true}
                                    searchIconWidth={'min-content'}
                                    //border={'1px solid #EBEDED'}
                                    borderLeft={'none'}
                                    margin={'0px'}
                                    fontSize={'14px'}
                                    iconColor={'#140F4B'}
                                    fontWeight={'bold'}
                                    //  handleKeyPress={handleKeyPress}
                                    //  clearSearch={handleClearSearch}
                                    background={'none'}
                                    enterkeyhint={'search'}
                                    right={'6%'}
                                />
                            </SearchBoxContainer>
                            {viewFiltersLists.length !== 0 && <LineSeparator />}
                            {viewFiltersLists
                                .filter((value) => {
                                    if (searchValue == '') {
                                        return viewFiltersLists;
                                    } else if (
                                        value.name
                                            .toLowerCase()
                                            .includes(searchValue.toLowerCase())
                                    ) {
                                        return searchValue;
                                    }
                                })
                                .map((viewFiltersList, index) => {
                                    return (
                                        <React.Fragment
                                            key={viewFiltersList?.id}
                                        >
                                            <CommonRadioCheckboxFilter
                                                isRadio={true}
                                                key={viewFiltersList?.id}
                                                filterItemRadio={
                                                    viewFiltersList?.id ===
                                                    'All'
                                                        ? {
                                                              ...viewFiltersList,
                                                              id: 'All Roles',
                                                          }
                                                        : viewFiltersList
                                                }
                                                setSelectedCalendarView={(
                                                    filterItem,
                                                    radioName
                                                ) => {
                                                    setSelectedViewFilter(
                                                        filterItem,
                                                        radioName
                                                    );

                                                    updateSearch('');
                                                }}
                                                isChecked={
                                                    selectedViewFilter?.id
                                                        ? selectedViewFilter?.id ===
                                                          viewFiltersList?.id
                                                        : viewFiltersList?.selected
                                                }
                                                radioName={viewFilterName}
                                                width={width}
                                                whiteSpace={whiteSpace}
                                                overFlow={overFlow}
                                                textOverflow={textOverflow}
                                                isDefault={
                                                    showDefault
                                                        ? checkIfDefault(
                                                              viewFiltersList.id
                                                          )
                                                        : false
                                                }
                                                index={index}
                                                FiltersListslength={
                                                    viewFiltersLists.length - 1
                                                }
                                                paddingBottom={'10px'}
                                                smbWidth={smbWidth}
                                            >
                                                {isAccountView && (
                                                    <FilterAccountLabel
                                                        name={
                                                            viewFiltersList.name
                                                        }
                                                        accountId={
                                                            viewFiltersList.accountId
                                                        }
                                                        showFavourite={
                                                            showFavourite
                                                        }
                                                        isFavourite={
                                                            viewFiltersList?.isFavorite
                                                        }
                                                    />
                                                )}
                                            </CommonRadioCheckboxFilter>
                                        </React.Fragment>
                                    );
                                })}
                            {setDefaultAction ? (
                                <FilterComponentHeaderFooter>
                                    <Button
                                        show={true}
                                        width={'100%'}
                                        height={'38px'}
                                        clicked={() => {
                                            try {
                                                setDefaultCalendarView(
                                                    selectedViewFilter
                                                );
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        // primary={hasDefaultViewChanged()}
                                        disabled={!hasDefaultViewChanged()}
                                        variant={ hasDefaultViewChanged() ? ButtonStyles.primary : ButtonStyles.disabled}
                                    >
                                        <TextBold
                                            color={'#FFFF'}
                                            fontSize={'15px'}
                                        >
                                            {t('filter.setDefaultButton')}
                                        </TextBold>
                                    </Button>
                                </FilterComponentHeaderFooter>
                            ) : null}
                        </>
                    );
                } else {
                    return <></>;
                }
            })()}
        </FilterComponentWrapper>
    );
};

export default CustomizeFilterView;
